/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_A5Inputs */

const es_marketplace_seo_galicia_faq_a5 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sálvora está en la Ría de Arousa: más íntima y menos masificada. Las Cíes, frente a Vigo, son más conocidas por sus playas pero con acceso más regulado. Ambas merecen una excursión en barco.`)
};

const gl_marketplace_seo_galicia_faq_a5 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sálvora está na Ría de Arousa: máis íntima e menos masificada. As Cíes, fronte a Vigo, son máis coñecidas polas súas praias pero con acceso máis regulado. Ambas merecen unha excursión en barco.`)
};

const en_marketplace_seo_galicia_faq_a5 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sálvora is in Ría de Arousa: more intimate and less crowded. Cíes, off Vigo, are famous for beaches but access is more regulated. Both deserve a boat trip.`)
};

/**
* | output |
* | --- |
* | "Sálvora is in Ría de Arousa: more intimate and less crowded. Cíes, off Vigo, are famous for beaches but access is more regulated. Both deserve a boat trip." |
*
* @param {Marketplace_Seo_Galicia_Faq_A5Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_a5 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_A5Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_A5Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_a5(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_a5(inputs)
	return es_marketplace_seo_galicia_faq_a5(inputs)
});